import { DataBean } from "../DataBean";

export class BudgetID extends DataBean {

    public async getBudgetIDByKey(idlnBudget: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.budget.BudgetID_getBudgetIDByKey_Number", [idlnBudget]);
    }
    public async getBudgetIDByCode(jsonCode: string): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.budget.BudgetID_getBudgetIDByCode_String", [jsonCode]);
    }
    public async getExpensivesBudgetIDType(year: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.budget.BudgetIDType_getExpensivesBudgetIDType_Number", [year]);
    }
    public async getBudgetYearByProps(page:number|null,rows:number|null,year: number,props:any): Promise<any> {
        return this.getCustomService("FinanceCore", "com.advantage.shared.Report_getBudgetYearByProps_Number_Number_Number_java.util.Map", [page,rows,year,props]);
    }
    public async getBudgetDescriptionReport(page:number|null,rows:number|null,year: number,month:number|null,props:any): Promise<any> {
        return this.getCustomService("FinanceCore", "com.advantage.shared.Report_getBudgetDescriptionReport_Number_Number_Number_Number_java.util.Map", 
            [page,rows,year,month,props]);
        }
        public async getBudgetYearByAdquisitionItemProps(page:number|null,rows:number|null,year: number,props:any): Promise<any> {
            return this.getCustomService("FinanceCore", "com.advantage.shared.Report_getBudgetYearByAdquisitionItemProps_Number_Number_Number_java.util.Map", 
                [page,rows,year,props]);
    }
    public async getListBudgetDocumentByProps(page:number|null,rows:number|null,year: number,docType:string,props:any,fromDate:any,uptoDate:any): Promise<any> {
        return this.getCustomService("FinanceCore", "com.advantage.shared.Report_getListBudgetDocumentByProps_Number_Number_Number_String_java.util.Map_java.util.Date_java.util.Date", 
            [page,rows,year,docType,props,fromDate,uptoDate]);
        }
    public async getBudgetExecution(year:number, props: any): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getBudgetExecution_Number_java.util.Map", [year,props]);
    }
    public async getBudgetByMonth(year:number,month:number,page:number,rows:number, props: any): Promise<any> {
        return this.getCustomService("FinanceCore", "com.advantage.shared.Report_getBudgetByMonth_Number_Number_Number_Number_java.util.Map",
             [year,month,page,rows,props]);
    }
    public async getEgresoReport(page:number,rows:number, props: any,year:number,month:number): Promise<any> {
        return this.getCustomService("FinanceCore", "com.advantage.shared.Report_getEgresoReport_Number_Number_java.util.Map_Number_Number",
             [page,rows,props,year,month]);
    }
    public async getBudgetInfoConsolidateByYear(year:number,page:number,rows:number, props: any): Promise<any> {
        return this.getCustomService("FinanceCore", "com.advantage.shared.Report_getBudgetInfoConsolidateByYear_Number_Number_Number_java.util.Map",
             [year,page,rows,props]);
    }
    public async getRPDetailByYear(year:number,page:number,rows:number, props: any): Promise<any> {
        return this.getCustomService("FinanceCore", "com.advantage.shared.Report_getRPDetailByYear_Number_Number_Number_java.util.Map",
             [year,page,rows,props]);
    }

}
